import React from "react";
import { StyleSheet, TouchableOpacity, Text, View, Platform } from "react-native";

import ImageComponent from "../../common/ImageComponent";
import {convertToRGBA, getGroupImageTag, isBaseCoreElement} from "../../../../helpers/utils";
import GroupIcons from "../../common/icons/groups";
import AppTheme from "../../AppTheme";

export default function ActivityGroup({
  set,
  preSelected = false,
  onPress = () => {},
}) {
  const isBaseGroup = isBaseCoreElement(set.name);
  const ImageTag = isBaseGroup ? getGroupImageTag(set.name) : ImageComponent;

  return (
    <TouchableOpacity
      onPress={() => onPress(set)}
      style={[
        styles.set,
        { opacity: set.isSelected || preSelected ? 1 : 0.5 },
        {
          backgroundColor: convertToRGBA(
            set.color ? set.color : AppTheme.DEFAULT_COLOR,
            1,
          ),
        },
      ]}
    >
      {set.icon ? (
        <View
          style={[
            styles.setIconContainer,
            isBaseGroup ? { backgroundColor: "transparent" } : {},
          ]}
        >
          <ImageTag
            icon={set.icon}
            style={isBaseGroup ? styles.baseSetIcon : styles.setIcon}
          />
        </View>
      ) : null}

      <Text style={[styles.setText, set.isSelected ? styles.selectedText : {}]}>
        {set.name}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  set: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "46%",
    maxWidth: 168,
    height: 53,
    borderRadius: 5,
    margin: 4,
  },
  setIconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FFF",
    borderRadius: 5,
    width: 33,
    height: 33,
    marginHorizontal: 10,
  },
  baseSetIcon: {
    width: 32,
    height: 32,
  },
  setIcon: {
    width: 20,
    height: 20,
  },
  setText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#FFF",
    display: "flex",
    alignItems: "center",
    opacity: 1,
  },
  selectedText: {
    color: "#FFF",
    opacity: 1,
  },
});
